<h1>{{ 'referentiels.list.natureProperties.caption' | transloco }}</h1>

@if (userHasReadWritePermission) {
  <p-button [size]="'small'" pRipple [rounded]="true" label="{{ 'button.add' | transloco }}" icon="pi pi-plus" class="btn-light" (onClick)="ajouterNature()"></p-button>
}

<p-table
  #natureTable
  [value]="natureResult"
  selectionMode="single"
  [(selection)]="selectedNature"
  dataKey="id"
  editMode="row"
  [rows]="25"
  [rowsPerPageOptions]="[10, 25, 50]"
  [resizableColumns]="true"
  columnResizeMode="expand"
  styleClass="p-datatable-striped"
  [paginator]="true"
  [totalRecords]="totalRecords"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{{'jgrid.defaults.recordtext' | transloco}} {first} - {last} {{'jgrid.defaults.recordtextOf' | transloco}} {totalRecords}"
>
  <ng-template pTemplate="header">
    <!-- Headers -->
    <tr>
      <th *ngIf="userHasReadWritePermission" style="width: 5%"></th>
      <th pResizableColumn pSortableColumn="codeHecate" style="width: 40%">{{'referentiels.list.natureProperties.codeHecate.header' | transloco }} <p-sortIcon field="codeHecate" /></th>
      <th pResizableColumn pSortableColumn="designation" style="width: 40%">{{ 'referentiels.list.natureProperties.designation.header'| transloco }} <p-sortIcon field="designation" /></th>
    </tr>

    <!-- Filters Inputs -->
    <tr>
      <th *ngIf="userHasReadWritePermission"></th>
      <th>
        <p-columnFilter type="text" field="codeHecate" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par code hecate" [showMenu]="false" [showClearButton]="false" />
      </th>
      <th>
        <p-columnFilter type="text" field="designation" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par désignation" [showMenu]="false" [showClearButton]="false" />
      </th>
    </tr>
  </ng-template>

  <!-- Body -->
  <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
    <ng-container [formGroup]="natureForm">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRowSelect(rowData)">
        <td *ngIf="userHasReadWritePermission">
          <!-- Column for edit/save buttons -->
          <div class="flex align-items-center justify-content-center">
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="modifierNature(rowData, ri)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" size="small" pTooltip="{{ 'button.validate' | transloco }}" (click)="validerModifsNature(rowData)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" size="small" pTooltip="{{ 'button.cancel' | transloco }}" (click)="annulerModifsNature(rowData, ri)"></button>
          </div>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="codeHecate" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.codeHecate }}
            </ng-template>
          </p-cellEditor>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="designation" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.designation }}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">{{ 'jgrid.defaults.emptyrecords' | transloco }}.</td>
    </tr>
  </ng-template>
</p-table>
<p-toast />
